/**
 * Returns the value at the given path of the given object
 * @param {Object} object
 * @param {String} path
 * @param {String} defaultValue
 * @return {String}
 */
const getObjectProperty = (object, path, defaultValue) => {
  const pathParts = path.split('.');
  if (typeof object === 'object' && pathParts.length) {
    const childObject = object[pathParts[0]];
    const childPath = pathParts.slice(1).join('.');

    if (childObject && pathParts.length > 1) {
      return getObjectProperty(childObject, childPath, defaultValue);
    }
    return childObject || defaultValue;
  }
  return defaultValue;
};

export default getObjectProperty;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/getObjectProperty.js